import React from 'react'
import SvgMapper from '../../features/common/SvgMapper';

const TranscriptTab = () => {
    const transcript = [
        { time: '00:00', speaker: 'Interviewer', text: 'Hello Sarah, thank you for joining us today. Let\'s start with you telling me about yourself.' },
        { time: '00:15', speaker: 'Sarah', text: "Thank you for having me. I'm Sarah Johnson, a recent marketing graduate with a passion for digital advertising. I've completed internships at two agencies where I worked on Meta and Google campaigns..." },
        { time: '02:15', speaker: 'Interviewer', text: 'Tell me about your experience with Meta advertising campaigns.' },
        { time: '02:18', speaker: 'Sarah', text: "I managed several Meta campaigns during my internship at XYZ Agency. We worked with e-commerce clients and achieved an average ROAS of 4.2x across 15 campaigns..." },
    ];
    return (
        <>
            <div className="flex items-center justify-between">
                <h3 className="text-lg font-semibold text-gray-900">Full Interview Transcript</h3>
                <button
                    className="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 text-sm flex items-center space-x-2"
                    aria-label="Download transcript"
                >
                    {SvgMapper.download("w-4 h-4")}
                    <span>Download</span>
                </button>
            </div>


            <div className="bg-gray-50 p-6 rounded-lg">
                <div className="space-y-4 text-sm">
                    {transcript.map((item, idx) => (
                        <div key={idx} className="flex space-x-3">
                            <span className="font-medium text-blue-600 min-w-[80px]">[{item.time}]</span>
                            <span className="font-medium text-gray-900">{item.speaker}:</span>
                            <span className="text-gray-700 flex-1 break-words">{item.text}</span>
                        </div>
                    ))}

                    {transcript.length > 0 && (
                        <div className="text-center py-4">
                            <span className="text-gray-500 italic">... transcript continues ...</span>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default TranscriptTab
